import '~/assets/scss/agents.scss'


import Form from '~/js/modules/form';
import getSwiperSlider from '~/js/modules/slider';

window.addEventListener(`DOMContentLoaded`, () => {
  const forms = document.querySelectorAll(`.form-b__form`);

  if (forms.length) {
    forms.forEach((form) => new Form(form));
  }

  const objectsSlider = document.querySelector(`.s-objects__slider`),
    objectsSwiperParams = {
      slidesPerView: 1.1,
      loop: false,
      autoplay: false,
      spaceBetween: 10,
      navigation: {
        nextEl: `.s-objects .slider-arrows__arrow--next`,
        prevEl: `.s-objects .slider-arrows__arrow--prev`,
        disabledClass: `disabled`,
      },
      pagination: false,
      breakpoints: {
        320: {
        },
        480: {
        },
        1024: {
          slidesPerView: 1.7,
          spaceBetween: 25,
        }
      }
    };
  if (objectsSlider) {
    getSwiperSlider(objectsSlider, objectsSwiperParams);
  }

  const getPresentationButton = document.querySelector('.js-legal-presentation-get');
  const windowPresentation = document.querySelector('.js-legal-presentation-window');
  const closeWindow = document.querySelectorAll('.js-close-presentation')
  if (getPresentationButton) {
    getPresentationButton.addEventListener('click', function (e) {
      if (windowPresentation) {
        windowPresentation.classList.add('active');

        if (closeWindow) {
          closeWindow.forEach((item) => {
            item.addEventListener('click', function (e) {
              windowPresentation.classList.remove('active');
            })
          })
        }
      }
    })
  }
  //так как слайдер перекрывает стандартный якорь
  const pageAnchors = document.querySelectorAll('.js-anchor');
  if (pageAnchors.length) {
    pageAnchors[0].classList.add('active')
    pageAnchors.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const headerOffset = document.querySelector(".header").offsetHeight;
        const hrefDestination = document.querySelector(this.getAttribute('href'));

        let offsetPosition = hrefDestination.getBoundingClientRect().top + document.documentElement.scrollTop - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      });
    });
  }

  const imagesGallery = document.querySelectorAll('.js-image-fullscreen');
  const bodyTag = document.querySelector('body');

  if (imagesGallery.length) {
    imagesGallery.forEach(image => {
      image.addEventListener('click', function() {
        image.classList.toggle('is-gallery');
        bodyTag.classList.toggle('no-scroll')
      })
    })
  }

  window.addEventListener('scroll', function() {
    pageAnchors.forEach(anchor => {
      const headerOffset = document.querySelector(".header").offsetHeight;
      const hrefDestination = document.querySelector(anchor.getAttribute('href'));
      const anchorOffset = document.querySelector(".js-nav-menu").offsetHeight;
      let offsetPosition;
      if(window.innerWidth >= 1024) {
        offsetPosition = hrefDestination.getBoundingClientRect().top + document.documentElement.scrollTop - headerOffset;
      }
      else {
        offsetPosition = hrefDestination.getBoundingClientRect().top + document.documentElement.scrollTop - headerOffset - anchorOffset;
      }

      if(Math.floor(scrollY) >= Math.floor(offsetPosition)) {
        pageAnchors.forEach(anchor => {
          anchor.classList.remove('active')
        })
        anchor.classList.add('active')
      }
    })
  })
});